/**
 * API path constants for rule recommendations
 * Centralized to eliminate duplication and ensure consistency
 */

// Base API path for all rule recommendations endpoints
export const API_PATH_BASE = '/ECMv6/api/intelligence/ruleRecommendations';

// Specific endpoint paths
export const RULES_PATH = `${API_PATH_BASE}/rules`;
export const RULES_FILTER_OPTIONS_PATH = `${API_PATH_BASE}/rules/filter-options`;
export const SUMMARY_PATH = `${API_PATH_BASE}/summary`;
